import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum IndividualRegistrationFormErrorStatesEnum {
    ChangeStatusFailed = ErrorStateScheduleEnum.IndividualRegistrationFormStatesStartIndex,
    EmailMissed,
    PortalsMissed,
    TypeBehaviorMissed,
    SendUserConfirmationEmailFailed
}
